import { apiProxyRequest } from "Api/apiProxyRequest";
import { UpdateDeploymentSettingsResponse } from "Reducers/environment/deployment";

import { getDeploymentSettingsUrl } from "./environments/deployments/utils";

export const updateDeploymentSettingsRequest = ({
  projectId,
  environmentId,
  manualDeploymentsEnabled
}) => {
  return apiProxyRequest<UpdateDeploymentSettingsResponse>(
    getDeploymentSettingsUrl({ projectId, environmentId }),
    "PATCH",
    {
      enable_manual_deployments: manualDeploymentsEnabled
    }
  );
};
